<div class="book-container">
  <div class="book-container-overlay"></div>
  <div class="container">
    <div class="main-row">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <h3 *ngIf="office">{{ office.city + ' ' + office.address}}</h3><br>
        </div>
      </div>
      <div class="row" *ngIf="office && office.city === 'Haifa'">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="alert alert-danger" role="alert" [dir]="languageService.getDir()"
               [class.text-right]="languageService.isCurrent('Hebrew')">
            {{ 'BOOK.HAIFA_ALERT_MESSAGE' | translate }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <form [formGroup]="bookForm" (ngSubmit)="bookFormSubmit()">
            <div class="form-row">
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="roomId" [dir]="languageService.getDir()">{{ 'BOOK.OFFICE' | translate }}</label>
                <select id="roomId" class="form-control" formControlName="roomId"
                        [class.text-right]="languageService.isCurrent('Hebrew')">
                  <option *ngFor="let room of rooms" [value]="room.id" [class.text-right]="languageService.isCurrent('Hebrew')">
                    {{ languageService.isCurrent('Hebrew') ? room.nameHe : room.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="bookingOption" [dir]="languageService.getDir()">{{ 'BOOK.BOOKING_OPTION' | translate }}</label>
                <select id="bookingOption" class="form-control" formControlName="bookingOption"
                        [class.text-right]="languageService.isCurrent('Hebrew')">
                  <option value="default"></option>
                  <option *ngFor="let bookingPrice of bookingPrices"
                          [value]="bookingPrice.bookingOption" [class.text-right]="languageService.isCurrent('Hebrew')">
                    {{ 'ENUM.BOOKING_OPTION_WITH_PRICE.' + bookingPrice.bookingOption | translate: { price: bookingPrice.price, discountText: find(bookingPrice.bookingOption) } }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row" [hidden]="bookForm.get('bookingOption').value === 'ONE_SEAT_QUICK_CARD_5D' || bookForm.get('bookingOption').value === 'ONE_SEAT_QUICK_CARD_10D'">
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="startDate" [dir]="languageService.getDir()">
                  <ng-container *ngIf="bookForm.get('bookingOption').value !== 'ONE_SEAT_WEEK' && bookForm.get('bookingOption').value !== 'ONE_SEAT_MONTH'">
                    {{ 'BOOK.SELECT_DATE' | translate }}
                  </ng-container>
                  <ng-container *ngIf="bookForm.get('bookingOption').value === 'ONE_SEAT_WEEK' || bookForm.get('bookingOption').value === 'ONE_SEAT_MONTH'">
                    {{ 'BOOK.START_DATE' | translate }}
                  </ng-container>
                </label>
                <div class="input-group">
                  <input type="text" id="startDate" name="startDate" class="form-control" placeholder="dd.mm.yyyy"
                         ngbDatepicker #sd="ngbDatepicker" firstDayOfWeek="0" [markDisabled]="markDisabled"
                         [minDate]="minDate" [dir]="languageService.getDir()"
                         formControlName="startDate">
                  <button class="btn btn-outline-secondary calendar" (click)="sd.toggle()" type="button">
                    <i class="fas fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-row" [hidden]="bookForm.get('bookingOption').value !== 'ONE_SEAT_WEEK'
                && bookForm.get('bookingOption').value !== 'ONE_SEAT_MONTH'
                && bookForm.get('bookingOption').value !== 'ONE_SEAT_QUICK_CARD_5D'
                && bookForm.get('bookingOption').value !== 'ONE_SEAT_QUICK_CARD_10D'
                && bookForm.get('bookingOption').value !== 'ONE_SEAT_90DAYS'
                && bookForm.get('bookingOption').value !== 'ONE_SEAT_180DAYS'
                && bookForm.get('bookingOption').value !== 'ONE_SEAT_360DAYS'"
            >
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="endDate" [dir]="languageService.getDir()">{{ 'BOOK.END_DATE' | translate }}</label>
                <div class="input-group">
                  <input type="text" id="endDate" name="endDate" class="form-control" placeholder="dd.mm.yyyy"
                         ngbDatepicker #ed="ngbDatepicker" firstDayOfWeek="0"
                         [minDate]="minDate" [dir]="languageService.getDir()"
                         formControlName="endDate" readonly>
                  <button class="btn btn-outline-secondary calendar" (click)="ed.toggle()" type="button" disabled>
                    <i class="fas fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-row" [hidden]="bookForm.get('bookingOption').value !== 'ENTIRE_OFFICE_HALF_DAY' && bookForm.get('bookingOption').value !== 'ONE_SEAT_2HOURS'">
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="timeSlot" [dir]="languageService.getDir()">{{ 'BOOK.TIME' | translate }}</label>
                <select id="timeSlot" class="form-control" formControlName="timeSlot" [class.text-right]="languageService.isCurrent('Hebrew')">
                  <option *ngFor="let slot of slots" [value]="slot" [dir]="languageService.getDir()">{{ slot }}</option>
                </select>
              </div>
            </div>
            <div class="form-row" [hidden]="bookForm.get('bookingOption').value !== 'ENTIRE_OFFICE_HOUR'">
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="startTime" [dir]="languageService.getDir()">{{ 'BOOK.START_TIME' | translate }}</label>
                <select id="startTime" class="form-control" formControlName="startTime" [class.text-right]="languageService.isCurrent('Hebrew')">
                  <option value="default"></option>
                  <option *ngFor="let hour of startHours" [value]="hour" [dir]="languageService.getDir()">{{ hour }}</option>
                </select>
              </div>
            </div>
            <div class="form-row" [hidden]="bookForm.get('bookingOption').value !== 'ENTIRE_OFFICE_HOUR'">
              <div class="col-md-12 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="endTime" [dir]="languageService.getDir()">{{ 'BOOK.END_TIME' | translate }}</label>
                <select id="endTime" class="form-control" formControlName="endTime" [class.text-right]="languageService.isCurrent('Hebrew')">
                  <option value="default"></option>
                  <option *ngFor="let hour of endHours" [value]="hour" [dir]="languageService.getDir()">{{ hour }}</option>
                </select>
              </div>
            </div>
            <div class="form-row" [dir]="languageService.getDir()">
              <div class="col-md-10 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <label for="coupon" [dir]="languageService.getDir()">Coupon</label>
                <input type="text" class="form-control" formControlName="coupon" [attr.disabled]="!!coupon" id="coupon">
              </div>
              <div class="col-md-2 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                <button type="button" class="btn btn-light apply-coupon-button w-100"
                        [disabled]="!this.bookForm.controls['coupon'].value || !!coupon"
                        (click)="applyCoupon()">Apply</button>
              </div>
            </div>
            <div class="form-row" [hidden]="!coupon">
              <div class="col-md-12 mt-3">
                <div class="alert alert-success" role="alert">
                  <ng-container *ngIf="coupon && CouponType.PERCENT === coupon.type">
                      Coupon applied. You have {{ coupon.value }} percents discount for this order
                  </ng-container>
                  <ng-container *ngIf="coupon && CouponType.AMOUNT === coupon.type">
                      Coupon applied. You have {{ coupon.value }}₪ discount for this order
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="form-row" [dir]="languageService.getDir()"
                 [hidden]="bookForm.get('bookingOption').value !== 'ONE_SEAT_MONTH'">
              <div class="input-group input-group-monthly">
                <div class="col-md-3 pl-2 pr-2 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')">
                  <label>
                    <span class="ml-2 mr-2">Auto renew</span>
                    <input type="checkbox" id="monthSubscribe" formControlName="monthSubscribe">
                  </label>
                </div>
                <div class="col-md-9 pl-2 pr-1 mb-3" [class.text-right]="languageService.isCurrent('Hebrew')"
                  [hidden]="bookForm.get('bookingOption').value !== 'ONE_SEAT_MONTH' || !bookForm.get('monthSubscribe').value">
                  <label for="userId" [dir]="languageService.getDir()">User id</label>
                  <input type="text" class="form-control" formControlName="userId" id="userId">
                </div>
              </div>
            </div>
            <div class="form-row" [hidden]="bookForm.get('bookingOption').value !== 'ONE_SEAT_MONTH' || !bookForm.get('monthSubscribe').value">
              <div class="col-md-12 mt-3">
                <div class="alert alert-warning text-center" role="alert">
                  {{ 'BOOK.AUTO_RENEW_ALERT' | translate }}
                </div>
              </div>
            </div>

            <div class="form-row" [hidden]="userConfirmedDocs">
              <div class="input-group">
                <div class="checkbox-container text-center">
                  <label>
                    <input type="checkbox" class="text-right" id="confirmed" formControlName="confirmed">
                    I confirm
                  </label>
                  <div class="download-links">
                    <a href="/assets/files/Terms of Service for Quick Hub - 20-05-2024.pdf" download="File1.pdf">Terms of use </a>
                    <a href="/assets/files/Quick Hub Privacy Policy.pdf" download="File2.pdf">Privacy policy </a>
                    <a href="/assets/files/Terms of use Quick Hub Website - 20-05-2024.pdf" download="File2.pdf">Terms of use Website</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="book-button-container text-center">
                <button type="submit"
                        [disabled]="!bookForm.controls['confirmed'].value ||
                        (bookForm.get('bookingOption').value === 'ONE_SEAT_MONTH' &&
                        bookForm.get('monthSubscribe').value && !bookForm.get('userId').value)"
                        class="primary-button book-button">{{ 'BOOK.BOOK_NOW' | translate }}</button>
              </div>
            </div>
            <div class="form-group mt-3">
              <div class="alert alert-danger" role="alert" *ngIf="isError">{{ errorMessage }}</div>
            </div>
          </form>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div class="row">
            <div class="col-md-4 calendar-buttons">
              <div class="btn-group">
                <div class="btn btn-sm btn-outline-secondary" mwlCalendarPreviousView
                     [view]="view"
                     [(viewDate)]="viewDate"
                     (viewDateChange)="closeOpenMonthViewDay()" (click)="setVisibleHours()">
                  Prev
                </div>
                <div class="btn btn-sm btn-outline-secondary" mwlCalendarToday
                     [(viewDate)]="viewDate" (click)="setVisibleHours()">
                  Today
                </div>
                <div class="btn btn-sm btn-outline-secondary" mwlCalendarNextView
                     [view]="view"
                     [(viewDate)]="viewDate"
                     (viewDateChange)="closeOpenMonthViewDay()" (click)="setVisibleHours()">
                  Next
                </div>
              </div>
            </div>
            <div class="col-md-4 text-sm-center">
              <div>{{ viewDate | calendarDate:(view + 'ViewTitle'):(languageService.isCurrent('Hebrew') ? 'he' : 'en'):(languageService.isCurrent('Hebrew') ? 0 : 1) }}</div>
            </div>
            <div class="col-md-4">
              <div class="btn-group">
                <div class="btn btn-sm btn-outline-secondary"
                     (click)="setView(CalendarView.Month)"
                     [class.active]="view === CalendarView.Month">
                  Month
                </div>
                <div class="btn btn-sm btn-outline-secondary"
                     (click)="setView(CalendarView.Week)"
                     [class.active]="view === CalendarView.Week">
                  Week
                </div>
                <div class="btn btn-sm btn-outline-secondary"
                     (click)="setView(CalendarView.Day)"
                     [class.active]="view === CalendarView.Day">
                  Day
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" [ngSwitch]="view">
              <div class="calendar-container overflow-auto">
                <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day"
                                       [viewDate]="viewDate"
                                       [events]="events"
                                       [refresh]="refreshCalendar"
                                       [dayStartHour]="dayStartHour"
                                       [dayEndHour]="dayEndHour"
                                       [hourSegments]="4"
                                       [hourSegmentHeight]="15"
                                       [locale]="languageService.isCurrent('Hebrew') ? 'he' : 'en'"
                                       (eventTimesChanged)="eventTimesChanged($event)">
                </mwl-calendar-day-view>
                <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week"
                                        [viewDate]="viewDate"
                                        [events]="events"
                                        [refresh]="refreshCalendar"
                                        [locale]="languageService.isCurrent('Hebrew') ? 'he' : 'en'"
                                        [weekStartsOn]="languageService.isCurrent('Hebrew') ? 0 : 1"
                                        [dayStartHour]="0"
                                        [dayEndHour]="23"
                                        (eventTimesChanged)="eventTimesChanged($event)">
                </mwl-calendar-week-view>
                <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month"
                                         [viewDate]="viewDate"
                                         [events]="events"
                                         [locale]="languageService.isCurrent('Hebrew') ? 'he' : 'en'"
                                         [weekStartsOn]="languageService.isCurrent('Hebrew') ? 0 : 1"
                                         [refresh]="refreshCalendar"
                                         [activeDayIsOpen]="activeDayIsOpen"
                                         (eventTimesChanged)="eventTimesChanged($event)">
                </mwl-calendar-month-view>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
